angular.module('angus.directives').directive('sideMenu', [
    function() {
        return {
            templateUrl: 'templates/authenticated/layout/sideMenu/sideMenu.html'
        };
    }
]);